// import Dashboard from './Dashboard';

export default {
  priority: 99,
  path: 'dashboard',
  permissions: ["isNotAdmin",'RequestsMenu/RequestDashboardMenu'], //['RequestDashboardMenu'],
  // component: Dashboard,
  component: load(() => import(/* webpackChunkName: "Requests-Dashboard" */ './Dashboard')),
  name: app.translate('routes.home.requests.Dashboard'),
  icon: 'view-dashboard',
  drawer: true,
};


